import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

type ProductSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

function ProductSearch({ value, onChange, placeholder }: ProductSearchProps) {
  return (
    <div className="relative">
      <Search aria-hidden className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-white/60" />
      <Input
        type="search"
        aria-label={placeholder}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-11 rounded-xl border-white/15 bg-white/[0.04] pl-9 pr-11 text-foreground placeholder:text-white/60 [&::-webkit-search-cancel-button]:hidden"
      />
      {value ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Clear search"
          onClick={() => onChange('')}
          className="absolute right-0 top-1/2 size-11 -translate-y-1/2 text-white/70 hover:bg-transparent hover:text-white"
        >
          <X className="size-4" />
        </Button>
      ) : null}
    </div>
  );
}

export default ProductSearch;
